import React from "react"
import { baseUrlImg } from "../../config/api"

function formatDate(dateString) {
  const date = new Date(dateString)
  return date.toLocaleString("it-IT", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  })
}

const AmazonTicket = ({ arr }) => {
  const receiptData = arr.receipt ? JSON.parse(arr.receipt) : {}

  return (
    <div className="json_spedizionepro">
      <div
        className="d-flex justify-content-center mb-4"
        style={{ border: "unset" }}
      >
        <img src={`${baseUrlImg}/${arr.logo}`} alt="service logo" height={50} />
      </div>

      <div style={{ paddingTop: 10 }}>
        Data di scadenza:
        <span>{formatDate(receiptData.gcExpirationDate)}</span>
      </div>

      <div style={{ paddingTop: 10 }}>
        Importo: <span>{Number(receiptData.amount).toFixed(2)} €</span>
      </div>

      <div style={{ paddingTop: 10 }}>
        Codice Voucher: <span>{receiptData.gcClaimCode}</span>
      </div>

      <div style={{ paddingTop: 10 }}>
        ID Transazione: <span>{receiptData.gcId}</span>
      </div>
    </div>
  )
}

export default AmazonTicket
